import { render, staticRenderFns } from "./StaticTest.vue?vue&type=template&id=36f7bc32"
import script from "./StaticTest.vue?vue&type=script&lang=js"
export * from "./StaticTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports